import styled, { css } from 'styled-components';

import { DICTATION_PREVIEW_CLASS } from '~libs.desktop.ai-assistant';

export const AI_DICTATION_PREVIEW_CLASS = DICTATION_PREVIEW_CLASS;

export const StyledLockedEditor = styled.div<{ $locked: boolean }>`
   height: 100%;

   .${AI_DICTATION_PREVIEW_CLASS} {
      color: ${(props) => props.theme.disabledDarker};
      font-style: italic;
   }

   ${(props) =>
      props.$locked &&
      css`
         .sun-editor-editable {
            background-color: ${props.theme.disabledLighter};
            cursor: not-allowed;
         }

         .se-toolbar {
            display: none;
         }
      `}
`;

StyledLockedEditor.displayName = 'StyledLockedEditor';
